module.exports = __webpack_public_path__ + "single-post-img5.115c7a4f91ea05781781.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/src/assets/images/samples/single-post-img5.jpg
// module id = ../../../../../src/assets/images/samples/single-post-img5.jpg
// module chunks = styles